
export const TableViewMinHeight = (heightOffset = 270) => `calc(100vh - ${heightOffset}px)`;